import { differenceInSeconds } from 'date-fns';
import { BoardLiteData, UserLiteData } from '../../api/ApiTypes';
import { NotificationData } from '../../api/endpoints/notifications';
import { uuid } from '../../CodesThatsGottaGoSomewhereElse';

export interface NotificationGroup {
    id: string;
    type: string;
    sender: UserLiteData;
    board?: BoardLiteData;
    items: NotificationGroupItem[];
    createdAt: Date;
}

export interface NotificationGroupItem {
    id: string;
    entity: any;
    board?: BoardLiteData;
    data?: any;
    readAt?: Date;
}

const toItem = (item: NotificationData) => ({
    id: item.id,
    entity: item.entity,
    board: item.board,
    data: item.data,
    readAt: item.readAt,
});

const toGroup = (item: NotificationData) => ({
    id: uuid(),
    type: item.type,
    sender: item.sender,
    items: [toItem(item)],
    createdAt: item.createdAt,
});

export const NotificationGroup = Object.freeze({

    from(data: NotificationData[]) {
        data = data?.filter(x => !!x.entity) ?? [];
        if (data.length === 0) return [];

        // Assume they are already sorted by date
        const groups = [toGroup(data[0])] as NotificationGroup[];

        for (const next of data.slice(1)) {

            const latest = groups[groups.length - 1];

            // Criteria for grouping:
            const sameType = latest.type === next.type;
            const sameSender = latest.sender.id === next.sender.id;
            const withinMinute = Math.abs(differenceInSeconds(next.createdAt, latest.createdAt)) < 60;

            // If type is the same, and createdAt is within 1 minute of group, add to group
            if (sameType && sameSender && withinMinute) {
                latest.items.push(toItem(next));
            }
            // Otherwise, create a new group
            else {
                groups.push(toGroup(next));
            }
        }

        return groups;
    }

});
